<template>
    <svg version="1.1" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
        viewBox="0 0 32 32" xml:space="preserve" fill="currentColor">
        <g>
            <path d="M31,5H1C0.4,5,0,5.4,0,6v20c0,0.6,0.4,1,1,1h30c0.6,0,1-0.4,1-1V6C32,5.4,31.6,5,31,5z M29,20c0,0.6-0.4,1-1,1
            c-1.1,0-2,0.9-2,2c0,0.6-0.4,1-1,1H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2
            c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1V20z"/>
            <ellipse cx="16" cy="16" rx="4" ry="5"/>
        </g>
    </svg>
</template>